import { Building2, Check, X } from "lucide-react";
import { formatDistanceToNow } from "date-fns";
import { ptBR } from "date-fns/locale";
import { resolveDashboardMode } from "@/lib/dashboard-mode";
import { getRoleLabel } from "./role-meta";

type Convite = {
  id: string;
  token: string;
  role: string;
  createdAt: string | Date;
  organization: { name: string; types: string[] };
};

/** Uma organização convidando: nome, acesso e as duas respostas. */
export function LinhaDoConvite({
  convite,
  ocupado,
  onAceitar,
  onRecusar,
}: {
  convite: Convite;
  ocupado: boolean;
  onAceitar: () => void;
  onRecusar: () => void;
}) {
  return (
    <li className="flex flex-wrap items-center gap-2 px-3 py-2 text-[12px] sm:flex-nowrap">
      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-brand-100 text-brand-700 dark:bg-primary/15 dark:text-primary">
        <Building2 className="h-3.5 w-3.5" />
      </span>
      <div className="min-w-0 flex-1">
        <p className="truncate font-semibold text-zinc-900 dark:text-foreground">{convite.organization.name}</p>
        <p className="text-[11px] text-zinc-500 dark:text-muted-foreground">
          Como {getRoleLabel(convite.role as never, resolveDashboardMode(convite.organization.types as never))} ·
          convidado {formatDistanceToNow(new Date(convite.createdAt), { addSuffix: true, locale: ptBR })}
        </p>
      </div>
      <div className="flex shrink-0 items-center gap-1.5">
        <button
          type="button"
          onClick={onAceitar}
          disabled={ocupado}
          className="inline-flex h-7 items-center gap-1 rounded-md bg-emerald-600 px-2.5 text-[11px] font-semibold text-white transition-colors hover:bg-emerald-700 disabled:opacity-60"
        >
          <Check className="h-3 w-3" />
          Aceitar
        </button>
        <button
          type="button"
          onClick={onRecusar}
          disabled={ocupado}
          className="inline-flex h-7 items-center gap-1 rounded-md border border-red-200 px-2.5 text-[11px] font-semibold text-red-600 transition-colors hover:bg-red-50 disabled:opacity-60 dark:border-red-900/50 dark:text-red-400 dark:hover:bg-red-950/30"
        >
          <X className="h-3 w-3" />
          Recusar
        </button>
      </div>
    </li>
  );
}
